// Mirror of backend/dutchie/__init__.py:brand_slug — kept in lockstep so links
// generated client-side resolve cleanly on the server.
export function brandSlug(name) {
    if (!name) return "";
    return String(name)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
